import { ChangeDetectionStrategy, Component, Inject, Signal, computed, effect } from '@angular/core';

import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Store } from '@ngrx/store';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../../base/services/betslip-messages-provider.service';
import { AlertType } from '../../../../../alerts/models';
import { BetslipLinearTrackingService } from '../../../../../tracking/services/betslip-linear-tracking.service';
import { LinearResultCount } from '../../../../models/linear-result-summary.model';
import { selectLinearResultCount } from '../../../../selectors';

@Component({
    selector: 'bs-digital-linear-result-header',
    templateUrl: './linear-result-header.component.html',
    styleUrls: ['./linear-result-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultHeaderComponent {
    readonly messages: {
        betAccepted: string;
        betPartiallyAccepted: string;
    };

    readonly alertType = AlertType.Success;
    readonly resultMessage: Signal<string>;

    constructor(
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: ILinearBetslipMessagesProviderService,
        store: Store,
        trackingService: BetslipLinearTrackingService,
    ) {
        const messages = messageProvider.getMessages().linear;

        this.messages = {
            betAccepted: messages.BetAccepted,
            betPartiallyAccepted: messages.BetPartiallyAccepted,
        };

        const resultCount = store.selectSignal(selectLinearResultCount);

        this.resultMessage = computed(() => this.getMessageText(resultCount()));

        effect(() => {
            const resultMessage = this.resultMessage();

            trackingService.trackSuccessMessageLoad(resultMessage);
        });
    }

    private getMessageText({ numberOfBetsPlaced, numberOfTotalBets }: LinearResultCount): string {
        if (numberOfBetsPlaced === numberOfTotalBets) {
            return this.messages.betAccepted;
        }

        return interpolateDoubleBracesString(this.messages.betPartiallyAccepted, {
            countSuccess: numberOfBetsPlaced,
            countTotal: numberOfTotalBets,
        });
    }
}
